import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-search',
  templateUrl: './empty-search.component.html',
  styleUrls: ['./empty-search.component.scss']
})
export class EmptySearchComponent implements OnInit {

  @Input() removeAnimation: boolean = false;
  @Input() title: string = 'No se ha encontrado ningún usuario';
  @Input() message: string = 'Verifique si los datos están bien escritos e intente de nuevo.';
  constructor() { }

  ngOnInit() {
  }

}
